export default {
  "config": {
    "trial": "tones-3",
    "id": "pgic",
    "type": "bar",
    "title": "Participants With Improvement on the Patient Global Impression of Change Scale (mITT Population)<sup>23</sup>",
    "xAxis": {
      "groups": [
        "w1",
        "w4",
        "w8",
        "w12"
      ],
      "padding": 0.1,
      "label": {
        "text": "Week"
      },
      "overrides": {
        "w1": "Week 1",
        "w4": "Week 4",
        "w8": "Week 8",
        "w12": "Week 12"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 0,
      "high": 100,
      "inc": 10,
      "label": {
        "text": [
          "Participants with improvement",
          "on <no-break>PGI-C, %</no-break>"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo",
        "label": "Placebo<br><no-break>(n = 114)<no-break>",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "sol-375",
        "label": "<no-break>Solriamfetol 37.5 mg</no-break><br> <no-break>(n = 56)<no-break>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg"
      },
      {
        "entry": "sol-75",
        "label": "<no-break>Solriamfetol 75 mg</no-break> <br><no-break>(n = 58)<no-break>",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg"
      },
      {
        "entry": "sol-150",
        "label": "<no-break>Solriamfetol 150 mg</no-break><br> <no-break>(n = 116)<no-break>",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg"
      },
      {
        "entry": "sol-300",
        "label": "<no-break>Solriamfetol 300 mg</no-break><br> <no-break>(n = 115)<no-break>",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break>*<em>P</em> < 0.05</no-break> vs placebo;<no-break> <sup>#</sup><em>P</em> < 0.0001<no-break> vs placebo."
    ],
    "useFootnoteTooltip": false,
    "trendLines": [],
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo<br><no-break>(n = 114)<no-break>",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375",
            "label": "<no-break>Solriamfetol 37.5 mg</no-break><br> <no-break>(n = 56)<no-break>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75",
            "label": "<no-break>Solriamfetol 75 mg</no-break> <br><no-break>(n = 58)<no-break>",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150",
            "label": "<no-break>Solriamfetol 150 mg</no-break><br> <no-break>(n = 116)<no-break>",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300",
            "label": "<no-break>Solriamfetol 300 mg</no-break><br> <no-break>(n = 115)<no-break>",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "x": "w1",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 47.4,
          "label": {
            "text": 47.4,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 58.9,
          "label": {
            "text": 58.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 65.5,
          "label": {
            "text": 65.5,
            "sup": "*",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 78.3,
          "label": {
            "text": 78.3,
            "sup": "#",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 82.5,
          "label": {
            "text": 82.5,
            "sup": "#",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "w4",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 53.5,
          "label": {
            "text": 53.5,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 60.7,
          "label": {
            "text": 60.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 77.6,
          "label": {
            "text": 77.6,
            "sup": "*",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 84.5,
          "label": {
            "text": 84.5,
            "sup": "#",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 84.3,
          "label": {
            "text": 84.3,
            "sup": "#",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "w8",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 57,
          "label": {
            "text": 57,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 57.1,
          "label": {
            "text": 57.1,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 79.3,
          "label": {
            "text": 79.3,
            "sup": "*",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 88.8,
          "label": {
            "text": 88.8,
            "sup": "#",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 87.8,
          "label": {
            "text": 87.8,
            "sup": "#",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "w12",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 49.1,
          "label": {
            "text": 49.1,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 55.4,
          "label": {
            "text": 55.4,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 72.4,
          "label": {
            "text": 72.4,
            "sup": "*",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 89.7,
          "label": {
            "text": 89.7,
            "sup": "#",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 88.7,
          "label": {
            "text": 88.7,
            "sup": "#",
            "override": ""
          }
        }
      ]
    }
  ]
};